import { ControlProgramTagView } from "api/generated/model";
import { ActivableTag } from "components/tag/types";

function adaptTags(tags: Array<ControlProgramTagView>): Array<ActivableTag> {
    return tags.map((tag) => ({
        id: tag.id,
        name: tag.name,
        tagCategoryId: tag.controlProgramTagCategoryId,
        // XXX Control program tags cannot be deleted. This is correct.
        // However there will be no means to spot the necessary change if
        // one day we decide to add the flag.
        active: true,
    }));
}

export { adaptTags };
